export type BusyGuardInput = {
  isBusy: boolean;
  isResetting: boolean;
};

/**
 * 実行中なら理由を返す。null なら通してよい。
 *
 * 必ず「呼んだ時点の最新の busy 状態」を返すこと。値（`string | null`）や
 * render 時の値を捕捉した関数では、確認ダイアログの `onConfirm` が
 * 開いた時点のクロージャとして state に保存されるため、「開く → busy → 確定」で
 * 古い null を読む。ガードが素通りして mutation が飛ぶ（Task 10 設計書 :452-512）。
 */
export type GetBusyGuardReason = () => string | null;

/**
 * 自動配車の実行中に競合する書き込みを弾く（設計書 :498-512）。
 * 止める理由を返す。null なら通してよい。
 *
 * Why not isBusy だけを見る: controller の外で走る operationBulkResetting
 * （詳細パネルの「未割当へ戻す」など）を取りこぼす。
 */
export function resolveBusyGuardReason(input: BusyGuardInput): string | null {
  // **isResetting を先に見る。** isBusy は resetting を内包するので、順序を逆にすると
  // 「未割当に戻す」中に「自動配車の実行中です」と嘘をつく（同じ瞬間に画面右下は
  // 「未割当に戻しています…」と出ている）。
  // resolveConvenienceTariffAvailability.ts:48-53 と同じ順序・同じ文言。
  if (input.isResetting) return '配車を変更中です';
  if (input.isBusy) return '自動配車の実行中です';
  return null;
}
